<template>
    <v-modal
        @confirm="submit"
        :ok="ok"
        ref="modal"
        v-bind="$attrs"
        v-on="$listeners"
    >
        <div class="p-3" v-if="message">{{ message }}</div>
        <div class="alert alert-danger" v-if="error">{{ error }}</div>
        <template v-if="!completed">
            <div class="p-3">
                <h4>Coming soon in 2020</h4>
                <p>
                    Ladder for Android is coming in 2020 and we would love for
                    you to be the first to try it out. Add your information
                    below and we'll send you an email as soon as the app is
                    ready.
                </p>
                <hr />
                <v-form-field label="Name" v-model="visitor.name" />
                <v-form-field
                    class="mt-2"
                    label="Email Address"
                    v-model="visitor.email"
                />
                <v-form-field
                    class="mt-2"
                    label="Phone Number (Optional)"
                    v-model="visitor.phone"
                />
            </div>
        </template>
    </v-modal>
</template>

<script>
import VModal from "@/components/ui/VModal";
import VFormField from "@/components/ui/VFormField";

export default {
    name: "AndroidModal",
    components: {
        VFormField,
        VModal
    },
    data() {
        return {
            completed: false,
            message: null,
            error: null,
            visitor: {
                name: null,
                email: null,
                phone: null,
                android_mailing_list: true
            }
        };
    },
    computed: {
        ok() {
            return this.completed ? "Close" : "Send";
        }
    },
    watch: {
        "$attrs.show": to => {
            // Lazy load Intercom
            if (to) {
                require("@/services/Intercom.js");
            }
        }
    },
    methods: {
        submit() {
            this.error = null;
            if (this.completed) {
                this.$refs.modal.close();
            } else {
                if (this.visitor.email) {
                    // Add them to android list
                    window.Intercom("update", this.visitor);
                    // Add the user to our backend
                    this.$ladder
                        .create("/non-ios-users", this.visitor)
                        .then(res => {
                            this.message = res.message;
                            this.completed = true;
                        })
                        .catch(res => {
                            this.error = res.message;
                        });
                }
            }
        }
    }
};
</script>

<style></style>
